import { Component, OnInit, EventEmitter, Output, Input, OnChanges, ElementRef, HostListener } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CfetBaseComponent, CfetService, CFETILMEndpointsConstant } from '../../../cfet-core';
import { environment } from './../../../../environments/environment';
// Temporarily Added to show hard coded data
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-customer-eligibility-workplace',
    templateUrl: './customer-eligibility-workplace.component.html',
    styleUrls: ['./customer-eligibility-workplace.component.scss'],
    standalone: false
})
export class CustomerEligibilityWorkplaceComponent extends CfetBaseComponent implements OnInit, OnChanges {

  customerEligibilityWorkplaceFormGroup: UntypedFormGroup;
  stateValue: UntypedFormControl;
  zipCode: UntypedFormControl;
  searchValue: UntypedFormControl;
  disabledContinueButton = true;
  stateValueOption: any;
  stateList: any[] = [];
  selectedState: any;
  selectedZip: any;
  zipcodeError: boolean;
  showStateZipSection = true;
  showSelectedStateZip = false;
  showDontSeeWorkplaceManually = false;
  showSearchSection = false;
  displaySearchResult = false;
  noResultsFound = false;
  showEligibilityCompletion = false;
  selectedName: any;
  selectedAddress: any;
  selectedCity: any;
  selectedStateInWorkplace: any;
  selectedZipInWorkplace: any;
  checkState = '';
  workplaceList: any;
  searchResult: any;
  searchResultsFullData: any;
  searchedData: any = [];
  searchResultsCriteria: { entityName: string; };
  checkstateAndZip = { 'state': '', 'zipcode': '' };
  dropdowndefaultValue = true;
  getorgProfileInfo: any;
  profileData: any;
  showLoading = false;
  stateData: Array<any> = [];
  spaTerritories: Array<any> = [];

  @Output() eligibilitycompletionstatus = new EventEmitter<any>();
  @Output() editSelected = new EventEmitter<any>();
  @Output() workplaceSelected = new EventEmitter<any>();
  @Output() stateAndZipPresent = new EventEmitter<any>();
  @Input() showWorkplaceSection: boolean;
  @Input() showtickicon: boolean;
  @Input() stateAndZip: any;
  @Output() showLoadingSpinner = new EventEmitter<any>();
  @Output() manuallyAddedValues = new EventEmitter<any>();
  @Output() savedManualValues = new EventEmitter<any>();
  @Input() manuallyEnteredValues: any;
  @Output() showCancelModal = new EventEmitter<any>();

  constructor(
    private cfetService: CfetService,
    // Temporarily added for hard coded data
    private http: HttpClient,
    private elementRef: ElementRef) { super(); }

  ngOnChanges() {
    if (this.showWorkplaceSection === false) {
      this.showStateZipSection = false;
      this.showEligibilityCompletion = true;
      this.showSelectedStateZip = false;
      this.showSearchSection = false;
      this.showDontSeeWorkplaceManually = false;
      const eligibilitystatus = {
        completionStatus: this.showtickicon
      };
      this.eligibilitycompletionstatus.emit(eligibilitystatus);
    }
    if (this.stateAndZip !== undefined && this.stateAndZip !== '' && this.stateAndZip.org_name &&
      this.stateAndZip.org_name !== undefined) {
      this.selectedName = this.stateAndZip.org_name;
      this.selectedCity = this.stateAndZip.city;
      this.selectedAddress = this.stateAndZip.address;
      this.selectedZipInWorkplace = this.stateAndZip.zipcode;
      this.selectedStateInWorkplace = this.stateAndZip.state;
    }
    if (this.manuallyEnteredValues !== undefined && this.manuallyEnteredValues !== '' && this.manuallyEnteredValues.org_name) {
      this.selectedName = this.manuallyEnteredValues.org_name;
      this.selectedCity = this.manuallyEnteredValues.city;
      this.selectedAddress = this.manuallyEnteredValues.address;
      this.selectedZipInWorkplace = this.manuallyEnteredValues.zipcode;
      this.selectedStateInWorkplace = this.manuallyEnteredValues.state;
      this.checkstateAndZip['org_name'] = this.manuallyEnteredValues.org_name;
      this.checkstateAndZip['city'] = this.manuallyEnteredValues.city;
      this.checkstateAndZip['address'] = this.manuallyEnteredValues.address;
      this.checkstateAndZip['zipcode'] = this.manuallyEnteredValues.zipcode;
      this.checkstateAndZip['state'] = this.manuallyEnteredValues.state;
    }
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.stateValue = new UntypedFormControl('', [Validators.required]);
    this.searchValue = new UntypedFormControl('', [Validators.required]);
    this.zipCode = new UntypedFormControl('', { validators: [Validators.required, Validators.minLength(5)], updateOn: 'change' });
    this.customerEligibilityWorkplaceFormGroup = new UntypedFormGroup({
      stateValue: this.stateValue,
      searchValue: this.searchValue,
      zipCode: this.zipCode
    });
    this.stateValueOption = { 'value': 'Select', 'text': 'Select' };

    this.stateList = [];
    const commonListValues = JSON.parse(sessionStorage.getItem('ngStorage-commonListValues'));
    // get Valid SPA territories from session storage
    this.spaTerritories = commonListValues['validSPATerritories'];
    // get Valid States from session storage
    this.stateData = commonListValues['validStates'];
    this.setStateDataUsingSPATerritories();
    // sorting the state Data
    this.stateData.sort();
    if (this.stateData && this.stateData.length > 0) {
      // mapping the stateValue for value and text
      this.stateList = this.stateData.map(
        stateValue => {
          return { value: stateValue, text: stateValue.split(':')[1] };
        }
      );
    }
    if (this.stateAndZip !== undefined && this.stateAndZip !== '' && this.stateAndZip.state &&
      this.stateAndZip.state !== undefined && this.stateAndZip.state !== '') {
      this.stateValue.setValue(this.stateAndZip.state);
      this.zipCode.setValue(this.stateAndZip.zipcode);
      if (this.stateAndZip.state.indexOf(':') !== -1) {
        this.stateValueOption = { 'value': this.stateAndZip.state, 'text': this.stateAndZip.state.split(':')[1] };
      } else {
        this.stateValueOption = { 'value': this.stateAndZip.state, 'text': this.stateAndZip.state };
      }
      this.disabledContinueButton = false;
    }
    if (this.stateAndZip !== undefined && this.stateAndZip !== '' && this.stateAndZip.selectedState &&
      this.stateAndZip.selectedState !== undefined && this.stateAndZip.selectedState !== '') {
      this.selectedZip = this.stateAndZip.selectedZip;
      this.selectedState = this.stateAndZip.selectedState;
    }
    if (this.stateAndZip !== undefined && this.stateAndZip !== '' && this.stateAndZip.searchedResult &&
      this.stateAndZip.searchedResult !== undefined && this.stateAndZip.searchedResult !== '') {
      this.searchResultsFullData = this.stateAndZip.searchedResult;
    }
  }

  setStateDataUsingSPATerritories() {
    Object.keys(this.spaTerritories).forEach((key) => {
      let val = this.spaTerritories[key];
      this.stateData = this.stateData.concat(val);
    });
  }

  onChangeState(event) {
    this.checkState = '';
    // set stateValue
    this.stateValue.setValue(event.value);
    if (this.stateValue.value !== 'select') {
      // set false to dropdowndefaultValue
      this.dropdowndefaultValue = false;
      this.inputElementForSelectStateWithThisColor_333();
    } else {
      // set true to dropdowndefaultValue
      this.dropdowndefaultValue = true;
      this.inputElementForSelectStateWithThisColor_868585();
    }
    // invoke onValueChanges
    this.onValueChanges();
  }

  inputElementForSelectStateWithThisColor_333() {
    if (screen.width > 1024) {
      // if screen width greater than 1024
      const inputelem1 = this.elementRef.nativeElement.querySelector('#select_state');
      inputelem1.setAttribute('style', 'color : #333 !important');
    } else {
      const inputelem1 = this.elementRef.nativeElement.querySelector('#select_state').nextElementSibling;
      inputelem1.setAttribute('style', 'color : #333 !important');
    }
  }

  inputElementForSelectStateWithThisColor_868585() {
    const inputelem1 = this.elementRef.nativeElement.querySelector('#select_state');
    inputelem1.setAttribute('style', 'color : #868585 !important');
  }

  onValueChanges() {
    this.customerEligibilityWorkplaceFormGroup.valueChanges.subscribe(val => {
      if ((val.stateValue !== 'Select' && val.stateValue !== '') &&
        (val.zipCode !== '' && val.zipCode.replace(/[^0-9\-]/g, '').length > 4)) {
        this.disabledContinueButton = false;
      } else {
        this.disabledContinueButton = true;
      }
    });
  }

  @HostListener('document:click', ['$event']) clickout(event) {
    if (event.target.id !== 'select_state') {
      this.checkState = '';
    }
  }
  onClickState(event) {
    if (event.target.ariaExpanded === 'true') {
      this.checkState = 'dropdown-opened';
    } else {
      this.checkState = '';
    }
  }

  changeZip() {
    this.onValueChanges();
    this.checkZip();
  }

  checkZip() {
    this.zipcodeError = this.zipCode.value.replace(/[^0-9\-]/g, '').length < 5 ? true : false;
  }

  continue(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showSelectedStateZip = true;
      this.showStateZipSection = false;
      this.showSearchSection = true;
      this.zipCode.setValue(this.zipCode.value.replace(/[^0-9\-]/g, ''));
      this.selectedState = this.stateValue.value.split(':')[1] ? this.stateValue.value.split(':')[1] : this.stateValue.value.split(':')[0];
      this.checkstateAndZip = { 'state': this.stateValue.value, 'zipcode': this.zipCode.value.replace(/[^0-9\-]/g, '') };
      this.selectedZip = this.zipCode.value.replace(/[^0-9\-]/g, '');
      const requestParam = {
        // set state and zipcode
        "search_criteria": [
          {
            'attribute_name': 'state',
            'attribute_value': this.checkstateAndZip.state
          }, {
            'attribute_name': 'zipcode',
            'attribute_value': this.checkstateAndZip.zipcode
          }]
      };
      // scroll to top on the page
      window.scrollTo(0, 0);
      this.showLoading = true;
      // emit showLoadingSpinner with true
      this.showLoadingSpinner.emit(true);
      if (environment.enableAPICall) {
        this.cfetService.cfetLivePost(requestParam, CFETILMEndpointsConstant.SEARCH_DETAILS).subscribe((data: any) => {
          this.setSearchResults(data);
        }, (_error) => {
          this.showLoadingSpinner.emit(false);
          this.showLoading = false;
        });
      } else {
        // Remove on api integration
        this.http.get('assets/localResources/searchOrgDetails.json').subscribe((data: any) => {
          this.setSearchResults(data);
        }, (_error) => {
          this.showLoadingSpinner.emit(false);
          this.showLoading = false;
        });
      }
      this.stateAndZipPresent.emit(this.checkstateAndZip);
    }
  }

  setSearchResults(data) {
    if (data && data.length > 0) {
      this.showLoadingSpinner.emit(false);
      this.searchResult = [];
      this.showLoading = false;
      data.forEach(val1 => {
        let tempSearchList = { 'org_name': '', 'zipcode': '', 'address': '', 'city': '', 'state': '' };
        tempSearchList.org_name = val1.org_name;
        this.profileData = val1.profile;
        tempSearchList = this.setTempSearchList(tempSearchList);
        this.searchResult.push(tempSearchList);
      });
      this.searchResultsFullData = this.searchResult;
      this.checkstateAndZip['searchedResult'] = this.searchResult;
      this.checkstateAndZip['selectedState'] = this.stateValue.value;
      this.checkstateAndZip['selectedZip'] = this.zipCode.value.replace(/[^0-9\-]/g, '');
    } else {
      this.showLoadingSpinner.emit(false);
      this.showLoading = false;
    }
  }

  setTempSearchList(tempSearchList) {
    this.profileData.forEach(val2 => {
      if (val2.attribute_name === 'Address 1') {
        tempSearchList.address = val2.attribute_value;
      }
      if (val2.attribute_name === 'city') {
        tempSearchList.city = val2.attribute_value;
      }
      if (val2.attribute_name === 'zipcode') {
        tempSearchList.zipcode = val2.attribute_value;
      }
      if (val2.attribute_name === 'state') {
        tempSearchList.state = val2.attribute_value;
      }
    });
    return tempSearchList;
  }

  cancelCreation(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal.emit(true);
    }
  }

  editStateZip(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showSearchSection = false;
      this.showStateZipSection = true;
      this.showSelectedStateZip = false;
      this.displaySearchResult = false;
      this.showWorkplaceSection = undefined;
      this.noResultsFound = false;
      this.searchValue.setValue('');
    }
  }

  filterEntitywithSearchText(Entites, searchText, flag): any[] {
    const filteredData = [];
    if (Entites && Entites.length > 0) {
      Entites.forEach((entity) => {
        if (entity.org_name.toLowerCase().indexOf(searchText.entityName.toLowerCase()) !== -1) {
          filteredData.push(entity);
        }
      });
    }
    return filteredData;
  }

  searchWorkplace(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (this.searchValue.value.length >= 3) {
        this.searchResultsCriteria = { 'entityName': this.searchValue.value };
        this.searchedData = this.filterEntitywithSearchText(this.searchResultsFullData, this.searchResultsCriteria, false);
        if (this.searchedData.length > 0) {
          this.displaySearchResult = true;
          this.noResultsFound = false;
          this.workplaceList = [];
          this.workplaceList = this.workplaceList.concat(this.searchedData);
        } else {
          this.displaySearchResult = false;
          this.noResultsFound = true;
        }
      } else {
        this.noResultsFound = false;
        this.displaySearchResult = false;
      }
    }
  }

  addManually(event) {
    this.showSearchSection = false;
    this.showSelectedStateZip = false;
    this.displaySearchResult = false;
    this.showDontSeeWorkplaceManually = true;
  }

  // eligibility completion page section

  editWorkplace(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      if (this.stateAndZip.isPSEAffliationcode) {
        this.editStateZip(event);
        this.showSearchSection = false;
        this.showSelectedStateZip = false;
        this.showDontSeeWorkplaceManually = false;
        this.showEligibilityCompletion = false;
        this.zipCode.setValue('');
        this.stateValueOption = { 'value': 'Select', 'text': 'Select' };
      } else {
        this.showSelectedStateZip = true;
        this.displaySearchResult = false;
        this.showSearchSection = true;
        this.showDontSeeWorkplaceManually = false;
        this.showEligibilityCompletion = false;
        this.noResultsFound = false;
        this.searchValue.reset();
        const editIconSelected = {
          editIconSelected: true
        };
        this.editSelected.emit(editIconSelected);
      }
    }
  }

  onChangeWorkplace(event?, row?: any) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showEligibilityCompletion = true;
      this.showSearchSection = false;
      this.showSelectedStateZip = false;
      this.displaySearchResult = false;
      this.selectedName = row.org_name;
      this.selectedCity = row.city;
      this.selectedAddress = row.address;
      this.selectedZipInWorkplace = row.zipcode;
      if (row.state !== '' || row.state !== undefined) {
        this.selectedStateInWorkplace = row.state;
      }
      this.checkstateAndZip['org_name'] = row.org_name;
      this.checkstateAndZip['city'] = row.city;
      this.checkstateAndZip['address'] = row.address;
      this.checkstateAndZip['zipcode'] = row.zipcode;
      if (row.state !== '' || row.state !== undefined) {
        this.checkstateAndZip['state'] = row.state;
      }
      const workPlaceInfo = {
        completionStatus: true,
        selectedName: this.selectedName,
        selectedAddress: this.selectedAddress,
        selectedCity: this.selectedCity,
        selectedStateInWorkplace: this.selectedStateInWorkplace,
        selectedZipInWorkplace: this.selectedZipInWorkplace
      };
      this.eligibilitycompletionstatus.emit(workPlaceInfo);
      this.workplaceSelected.emit(true);
      this.searchValue.setValue('');
      this.stateAndZipPresent.emit(this.checkstateAndZip);
      this.manuallyEnteredValues = {};
    }
  }

  editWorkplaceOnManualEntry(event) {
    if (event !== undefined) {
      this.showSelectedStateZip = event;
      this.showSearchSection = event;
      this.searchValue.setValue('');
      this.showDontSeeWorkplaceManually = false;
      const editIconSelected = {
        editIconSelected: event
      };
      this.editSelected.emit(editIconSelected);
    }
  }

  signupDone(event) {
    const signupDoneStatus = {
      signupDoneStatus: event,
      completionStatus: true,
      selectedName: this.selectedName,
      selectedAddress: this.selectedAddress,
      selectedCity: this.selectedCity,
      selectedStateInWorkplace: this.selectedStateInWorkplace,
      selectedZipInWorkplace: this.selectedZipInWorkplace,
      searchResults: this.searchResultsFullData
    };
    this.eligibilitycompletionstatus.emit(signupDoneStatus);
  }

  manualCompleteStatus(event) {
    const eligibilityStatus = event;
    const eligibilityInfo = {
      eligibilityStatus: eligibilityStatus,
      manualEntry: true
    };
    this.eligibilitycompletionstatus.emit(eligibilityInfo);
  }

  manualValues(event) {
    this.manuallyAddedValues.emit(event);
  }

  saveManualValues(event) {
    if (event !== undefined && event.org_name && event.org_name !== '') {
      this.savedManualValues.emit(event);
    }
  }

  displayCancelModal(event) {
    if (event) {
      this.showCancelModal.emit(true);
    }
  }
}
